import * as React from 'react';
import * as QRCodeGenerator from 'qrcode';
import * as copy from 'copy-text-to-clipboard';

export interface IQRCodeProps {
  myTimerCode: number;
}

interface IQRCodeState {
  qrCodeBlobUrl: string
  copied: boolean;
}

export default class QRCode extends React.Component<IQRCodeProps, IQRCodeState> {

  constructor(props: IQRCodeProps) {
    super(props);
    this.state = {
      qrCodeBlobUrl: "",
      copied: false
    }
    this.generateQrCode = this.generateQrCode.bind(this);
    this.refreshQrCode = this.refreshQrCode.bind(this);
    this.copyQrCode = this.copyQrCode.bind(this);
  }

  public async componentDidMount() {
    this.refreshQrCode();
  }

  public componentDidUpdate(nextProps: IQRCodeProps, nextState: IQRCodeState) {
    if (nextProps.myTimerCode !== this.props.myTimerCode) {
      this.refreshQrCode();
    }
  }

  public render() {
    return (
      <div className="mt-1 text-center">
        <div className="text-center">
          <a href="" onClick={this.copyQrCode}>
            <img src={this.state.qrCodeBlobUrl} />
          </a>
          <br />
          {this.state.copied ?
            <small>Copied!</small>
            :
            <small>Click to copy the link</small>
          }
        </div>
      </div>
    );
  }

  private async refreshQrCode() {
    if (this.props.myTimerCode) {
      this.setState({
        qrCodeBlobUrl: await this.generateQrCode(),
        copied: false
      })
    }
  }

  private generateQrCode() {
    const url = this.getUrl(this.props.myTimerCode);
    return QRCodeGenerator.toDataURL(url);
  }

  private copyQrCode(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
    event.preventDefault();
    const url = this.getUrl(this.props.myTimerCode);
    copy(url);
    this.setState({
      copied: true
    });
  }

  private getUrl(myTimerCode: number) {
    return `${location.origin}/timer/remote/${myTimerCode}`;
  }
}



// WEBPACK FOOTER //
// ./src/Timer/QRCode.tsx